import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

require('./DownloadButton.css');

export type Props = {
    downloading: boolean;
    onClick(): void;
    percent: number;
};

const nop = () => {};

export const DownloadButton = ({ downloading, onClick, percent }: Props) => {
    const { t } = useTranslation();
    const [ id ] = useState(Math.random().toString(36).substring(2));

    return (
        <svg
            className={ `download-button ${downloading ? 'downloading' : ''}` }
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 640 505"
            onClick={ downloading ? nop : onClick }
        >
            <defs>
                <g id={ `${id}-arrow` }>
                    <path
                        className="arrow-1"
                        d="M263.45 283.54C229.53 283.54 208.34 283.54 199.86 283.54C186.66 283.54 179.49 298.98 188.01 309.06C211.68 337.09 267.74 403.45 293.06 433.42C300.18 441.85 313.02 442.27 320.68 434.33C349.75 404.17 412.68 338.88 439.26 311.31C449.3 300.9 441.92 283.54 427.46 283.54C418.3 283.54 395.39 283.54 358.73 283.54C358.73 225.07 358.73 188.52 358.73 173.9C358.73 163.46 350.26 155 339.83 155C324.55 155 298.11 155 282.96 155C272.18 155 263.45 163.73 263.45 174.51C263.45 189.05 263.45 225.39 263.45 283.54Z"
                    />
                    <path
                        className="arrow-2"
                        d="M263.45 283.54C229.53 283.54 208.34 283.54 199.86 283.54C186.66 283.54 179.49 298.98 188.01 309.06C211.68 337.09 267.74 403.45 293.06 433.42C300.18 441.85 313.02 442.27 320.68 434.33C349.75 404.17 412.68 338.88 439.26 311.31C449.3 300.9 441.92 283.54 427.46 283.54C418.3 283.54 395.39 283.54 358.73 283.54C358.73 225.07 358.73 188.52 358.73 173.9C358.73 163.46 350.26 155 339.83 155C324.55 155 298.11 155 282.96 155C272.18 155 263.45 163.73 263.45 174.51C263.45 189.05 263.45 225.39 263.45 283.54Z"
                    />
                </g>
                <rect
                    id={ `${id}-progress` }
                    className="download-progress"
                    x={ 10 }
                    y={ 495 - (485 * Math.max(0, Math.min(percent, 100)) / 100) }
                    width={ 620 }
                    height={ 485 * Math.max(0, Math.min(percent, 100)) }
                />
                <path
                    id={ `${id}-folder` }
                    className="folder"
                    d="M629.89 458.09C629.89 478.13 613.65 494.37 593.62 494.37C476.91 494.37 163.56 494.37 46.98 494.37C26.61 494.37 10.11 477.86 10.11 457.5C10.11 367.93 10.11 136.54 10.11 47.09C10.11 26.4 26.88 9.63 47.57 9.63C85.09 9.63 178.04 9.63 220.02 9.63C229.51 9.63 238.4 14.31 243.77 22.14C253.35 36.12 277.09 70.74 287.56 86.02C290.15 89.79 294.43 92.05 299 92.05C365.18 92.05 528.5 92.05 587.71 92.05C611 92.05 629.89 110.93 629.89 134.23C629.89 206.26 629.89 384.88 629.89 458.09Z"
                />
            </defs>
            <g>
                { /* The folder outline */ }
                <use xlinkHref={ `#${id}-folder` }/>

                { /* The progress indicator that fills up the folder */ }
                <clipPath id={ `${id}-clip2` }>
                    <use xlinkHref={ `#${id}-folder` }/>
                </clipPath>
                <use
                    clipPath={ `url(#${id}-clip2)` }
                    xlinkHref={ `#${id}-progress` }
                />

                { /* The descending arrows */ }
                <clipPath id={ `${id}-clip1` }>
                    <rect x={ 150 } y={ 145 } width={ 330 } height={ 295 }/>
                </clipPath>
                <use
                    clipPath={ `url(#${id}-clip1)` }
                    xlinkHref={ `#${id}-arrow` }
                />

                { /* The tool tip */ }
                <title>
                    { t(downloading ? 'VIDEO.EXPORTING' : 'VIDEO.EXPORT') }
                </title>
            </g>
        </svg>
    );
};
